namespace RecordShield.Workspace {
    export interface SingleDeviceLogRow {
        Id?: number;
        ActivationId?: number;
        SerialKey?: string;
        DeviceId?: string;
        DeviceType?: string;
        MachineCode?: string;
        SysInfo?: string;
        OpCode?: number;
        UserId?: number;
        AllowedDevices?: Models.Enums.AllowedDevices;
        Islocked?: boolean;
        InsertDate?: string;
        ActivationSerialKey?: string;
        ActivationSysInfo?: string;
        ActivationChannel?: number;
        ActivationStatus?: number;
        ActivationLog?: string;
        ActivationActivationId?: number;
        ActivationTenantId?: number;
        ActivationProductId?: number;
        ActivationUserId?: number;
        ActivationDeviceId?: string;
        ActivationDeviceType?: string;
        ActivationValidFrom?: string;
        ActivationValidTo?: string;
        ActivationProductSerialId?: number;
        ActivationAllowedDevices?: number;
    }

    export namespace SingleDeviceLogRow {
        export const idProperty = 'Id';
        export const nameProperty = 'SerialKey';
        export const localTextPrefix = 'Workspace.SingleDeviceLog';

        export namespace Fields {
            export declare const Id: string;
            export declare const ActivationId: string;
            export declare const SerialKey: string;
            export declare const DeviceId: string;
            export declare const DeviceType: string;
            export declare const MachineCode: string;
            export declare const SysInfo: string;
            export declare const OpCode: string;
            export declare const UserId: string;
            export declare const AllowedDevices: string;
            export declare const Islocked: string;
            export declare const InsertDate: string;
            export declare const ActivationSerialKey: string;
            export declare const ActivationSysInfo: string;
            export declare const ActivationChannel: string;
            export declare const ActivationStatus: string;
            export declare const ActivationLog: string;
            export declare const ActivationActivationId: string;
            export declare const ActivationTenantId: string;
            export declare const ActivationProductId: string;
            export declare const ActivationUserId: string;
            export declare const ActivationDeviceId: string;
            export declare const ActivationDeviceType: string;
            export declare const ActivationValidFrom: string;
            export declare const ActivationValidTo: string;
            export declare const ActivationProductSerialId: string;
            export declare const ActivationAllowedDevices: string;
        }

        ['Id', 'ActivationId', 'SerialKey', 'DeviceId', 'DeviceType', 'MachineCode', 'SysInfo', 'OpCode', 'UserId', 'AllowedDevices', 'Islocked', 'InsertDate', 'ActivationSerialKey', 'ActivationSysInfo', 'ActivationChannel', 'ActivationStatus', 'ActivationLog', 'ActivationActivationId', 'ActivationTenantId', 'ActivationProductId', 'ActivationUserId', 'ActivationDeviceId', 'ActivationDeviceType', 'ActivationValidFrom', 'ActivationValidTo', 'ActivationProductSerialId', 'ActivationAllowedDevices'].forEach(x => (<any>Fields)[x] = x);
    }
}
